export interface PetPolicyDto {
  id: string;
  allowsPets: boolean;
  smallDogsPolicy: PetPolicy;
  largeDogsPolicy: PetPolicy;
  catsPolicy: PetPolicy;
  otherPetsPolicy: PetPolicy;
  petRent: number | null;
  petDeposit: number | null;
  /** Charged once when a pet moves in */
  petFee: number | null;
  maxPets: number | null;
}

export enum PetPolicy {
  NotAllowed = 'Not allowed',
  Allowed = 'Allowed',
  BreedRestrictions = 'Breed restrictions',
  CaseByCase = 'Case by case',
  NotSpecified = 'Not specified',
}
